<template>
  <v-card flat>
    <v-toolbar dense flat color="#2A353D">
      <v-toolbar-title class="white--text subtitle-1 font-weight-normal">KYC COMPANY DOCUMENTS - {{currentClient.MajorName}}</v-toolbar-title>
      <v-spacer/>
      <v-btn fab outlined x-small color="white" @click="close()"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>

    <v-snackbar
       v-if="upload_dialog == false"
      :value="showMessage()"
      multi-line
      color="#686868"
      top
      
    >
      {{message}}
    </v-snackbar>

    <v-dialog v-if="currentDoc != null" persistent v-model="upload_dialog" max-width="500px">
      <v-snackbar
        :value="showMessage()"
        multi-line
        color="#686868"
        top
        
      >
        {{message}}
      </v-snackbar>
      <v-card class="d-flex flex-column justify-center text-center pa-6">
        <span class="subtitle-1 grey--text">{{currentDoc.label}}</span>

        <div align="center" justify="center">
          <v-progress-circular
            :size="80"
            :width="4"
            :indeterminate="submit? true:false"
            color="indigo"
            class="ma-4 mt-2"
          >
            <v-icon v-if="successful == true" color="indigo" x-large>mdi-check</v-icon>
            <v-icon v-else x-large>mdi-file-pdf</v-icon>
          </v-progress-circular>

          <div v-if="successful == false && message" class="grey--text subtitle-1 font-weight-normal">{{message}}</div>
          <div v-if="successful" class="grey--text subtitle-1 font-weight-normal mb-2">File uploaded successfully</div>
          <v-file-input accept="application/pdf" v-else outlined dense placeholder="Click here to select file" @change="selectFile"
          ></v-file-input>

          <span class="mt-4">
            <v-btn class="mx-1" outlined small color="#2A353D" @click="successful = false; upload_dialog = false; Doc[`${currentDoc.field}`] = false">close</v-btn>
            <v-btn class="white--text mx-1" v-show="!successful" v-if="existingRecord" small color="#2A353D" @click="submit = true, ColumnName = currentDoc.field; update()">upload</v-btn>
            <v-btn class="white--text mx-1" v-show="!successful" v-else small color="#2A353D" @click="submit = true, ColumnName = currentDoc.field; createNew()">upload</v-btn>
          </span>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-if="currentDoc != null" persistent v-model="deleteDialog" max-width="350px">
      <v-card>
        <v-card-title>
          <span class="subtitle-1 grey--text text-center ma-4 mx-7">Are you sure you want to DELETE  the selected item?</span>
        </v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="text-right mb-4">
            <v-btn class="white--text mr-3" small color="#2A353D" @click="deleteDialog = false">no</v-btn>
            <v-btn class="white--text mr-3" small color="#2A353D" @click="deleteDoc()">yes</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

<!-- ********************************************************************************************CREATE COM DOCS**************************************************************************************************
***************************************************************************************************************************************************************************************************** -->

    <v-list v-if="existingRecord == false">
      <template v-for="(item, index) in items">
        <v-list-item :key="item">
          <v-list-item-content>
            <span class="d-flex flex-row">
              <span
                class="d-inline-block text-truncate mt-1"
                style="width: 400px"
              >
                {{item.label}}
              </span>
              <v-spacer/>
              <v-chip class="mt-1" small color="warning">missing</v-chip>
              <v-spacer/>
              <span
                style="width: 300px"
                class="d-flex justify-end"
              >
                <v-btn
                  small outlined :disabled="edit" v-if="item.CheckerID == 0? item.MakerID == currentUser.SecurityUserID : showEditBtn == true"
                  @click="setActiveDoc(item, index); upload_dialog = true"
                  color="#2A353D" class="mr-3"
                >
                  <span>new doc</span>
                </v-btn>
                <v-btn
                  small outlined
                  disabled
                  @click="setActiveDoc(item, index); view = true"
                  color="#2A353D" class="mr-3"
                >
                  <span>view</span>
                </v-btn>
                <v-icon
                  :disabled="item.MakerID == currentUser.SecurityUserID && item.CheckerID == 0 ? false : true"
                  color="#2A353D" @click="setActiveDoc(item, index); deleteDialog = true"
                >
                mdi-trash-can-outline
                </v-icon>
              </span>
            </span>
          </v-list-item-content>
        </v-list-item>
        <v-divider
          class="ma-0 pa-0"
          v-if="index < items.length - 1"
          :key="index"
        ></v-divider>
      </template>
    </v-list>

<!-- ********************************************************************************************UPDATE COM DOCS**************************************************************************************************
***************************************************************************************************************************************************************************************************** -->

    <v-list v-else>
      <template v-for="(item, index) in items">
        <v-list-item :key="item">
          <v-list-item-content>
            <span class="d-flex flex-row">
              <span
                class="d-inline-block text-truncate mt-1"
                style="width: 400px"
              >
                {{item.label}}
              </span>
              <v-spacer/>
              <v-chip class="mt-1" dark small color="#A6D879" v-if="DocRecord[0][`${item.field}`] == 1">uploaded</v-chip>
              <v-chip class="mt-1" small color="warning" v-else>missing</v-chip>
              <v-spacer/>
              <span
                style="width: 300px"
                class="d-flex justify-end"
              >
                <v-btn
                  small outlined :disabled="edit" v-if="item.CheckerID == 0? item.MakerID == currentUser.SecurityUserID : showEditBtn == true"
                  @click="setActiveDoc(item, index); upload_dialog = true"
                  color="#2A353D" class="mr-3"
                >
                  <span>new doc</span>
                </v-btn>
                <v-btn
                  small outlined
                  :disabled="DocRecord[0][`${item.field}`] != 1"
                  @click="readDoc(item)"
                  color="#2A353D" class="mr-3"
                >
                  <span>view</span>
                </v-btn>
                <v-icon
                  :disabled="(allKYCDocs.filter(a => a.ClientID == currentClient.ClientID && a.DocType == item.field && a.IsCurrent == true).map(a => a.MakerID)[0] == currentUser.SecurityUserID) && (allKYCDocs.filter(a => a.ClientID == currentClient.ClientID && a.DocType == item.field && a.IsCurrent == true).map(a => a.CheckerID)[0] == 0) && DocRecord[0][`${item.field}`] == 1 ? false : true"
                  color="#2A353D" @click="setActiveDoc(item, index); deleteDialog = true"
                >
                mdi-trash-can-outline
                </v-icon>
              </span>
            </span>
          </v-list-item-content>
        </v-list-item>
        <v-divider
          class="ma-0 pa-0"
          v-if="index < items.length - 1"
          :key="index"
        ></v-divider>
      </template>
    </v-list>
  </v-card>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
// import UploadService from "../services/upload.service";
import administrationService from "../services/administration.service";
// import UserService from '../services/user.service';

export default {
  data () {
    return {
      currentDoc: null,
      message: "",
      valid: true,
      upload_dialog: false,
      deleteDialog: false,
      submit: false,
      successful: false,
      Doc: {
        EmpoweringResolution: false,
        InvContract: false,
        cif: false,
        SigningMndt: false,
        IncorpCertificate: false,
        MemoArticles: false,
        ShareholdersRegister: false,
        DirectorsRegister: false,
        AuditedAccounts: false,
        AuthorisedSignatories: false,
        AccountCopies: false,
        RegisteredAddr: false,
        BankAccStat: false,
        BoardMinutes: false,
        VATNumber: false,
        LetterToAtria: false
      },
      items: [
        {label: "Empowering Resolution", field: "EmpoweringResolution"},
        {label: "Investment Contract", field: "InvContract"},
        {label: "Client Information Form", field: "cif"},
        {label: "Signing Mandate", field: "SigningMndt"},
        {label: "Copy of certificate of incorporation", field: "IncorpCertificate"},
        {label: "Copy of Memorandum Articles of Association", field: "MemoArticles"},
        {label: "Register of Shareholders with percentage holding", field: "ShareholdersRegister"},
        {label: "Register of Directors (CR14)", field: "DirectorsRegister"},
        {label: "Latest audited accounts", field: "AuditedAccounts"},
        {label: "List of authorised signatories", field: "AuthorisedSignatories"},
        {label: "KYC for Executives", field: "AccountCopies"},
        {label: "Proof of registered address (CR6)", field: "RegisteredAddr"},
        {label: "Copy of bank statement and bank account details", field: "BankAccStat"},
        {label: "Board Minutes Approving the Investment", field: "BoardMinutes"},
        {label: "Proof of VAT number if registered", field: "VATNumber"},
        {label: "If not registered, a letter to us advising that not registered", field: "LetterToAtria"}
      ],
      FormData: {
        file: null,
        json: {
          ClientTypeID: null,
          ClientID: null,
          ColumnName: null,
          DocType: null,
          MakerID: null,
          LastUserID: null,
          Doc:{}
        }
      },
      currentFile: undefined,
      ColumnName: null,
    }
  },

  props: [
    'currentClient',
    'allComDocuments',
    'existingRecord'
  ],

  computed: {
    ...mapGetters([
      "allKYCDocs",
      "allConfirmationSettings"
    ]),
    currentUser() {
      return this.$store.state.auth.user;
    },
    DocRecord(){
      return this.allComDocuments.filter(a => a.ClientId == this.currentClient.ClientID)
    },
    showEditBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 302).map(r => r.AllowEdit)) == 1){
        return true
      }
    }
    return false;
    },

    showCreateBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 302).map(r => r.AllowCreate)) == 1){
        return true
      }
    }
    return false;
    },

    showConfirmBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 302).map(r => r.AllowConfirm)) == 1){
        return true
      }
    }
    return false;
    },

    CheckerID(){
      if(this.allConfirmationSettings.filter(a => a.FunctionID == 302).map(a => a.Status)[0] == false){
        return this.currentUser.SecurityUserID
      } else {
        return 0
      }
    }
  },

  methods: {
    ...mapActions([
      "createComDocument",
      "updateComDocument",
      "deleteComDocument"
    ]),

    createNew() {
      if (!this.currentFile) {
        this.message = "Please select a file!";
        return;
      }

      this.message = '';
      this.FormData.file = this.currentFile,
      this.FormData.json.ClientTypeID = 1,
      this.FormData.json.ClientID = this.currentClient.ClientID,
      this.FormData.json.ColumnName = this.ColumnName,
      this.FormData.json.DocType = "Company",
      this.FormData.json.Doc = this.Doc,
      this.FormData.json.MakerID = this.currentUser.SecurityUserID,
      this.FormData.json.CheckerID = this.CheckerID,
      this.FormData.json.LastUserID = this.currentUser.SecurityUserID,

      this.createComDocument(this.FormData)
      .then(response =>{
        this.$socket.client.emit('socketreq', {
          commit: 'newComDoc',
          data: response.data
        });
        this.successful = true;
        this.submit = false;
        this.message = response.data.message;
        this.currentFile = undefined;
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
        this.progress = 0;
        this.currentFile = undefined;
        this.submit = false;
      })
    },

    update() {
      if (!this.currentFile) {
        this.message = "Please select a file!";
        return;
      }

      this.DocRecord[0][this.currentDoc.field] = true,
      this.DocRecord[0].LastUserID = this.currentUser.SecurityUserID,
      this.DocRecord[0].CheckerID = 0,
      this.DocRecord[0].CheckDate = null,

      this.message = '';
      this.FormData.file = this.currentFile,
      this.FormData.json.ClientTypeID = 1,
      this.FormData.json.ClientID = this.currentClient.ClientID,
      this.FormData.json.ColumnName = this.ColumnName,
      this.FormData.json.DocType = "Company",
      this.FormData.json.MakerID = this.currentUser.SecurityUserID,
      this.FormData.json.Doc = this.DocRecord[0],

      this.updateComDocument(this.FormData)
      .then(response =>{
        this.$socket.client.emit('socketreq', {
          commit: 'updComDoc',
          data: response.data
        });
        this.successful = true;
        this.submit = false;
        this.message = response.data.message;
        this.currentFile = undefined;
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
        this.progress = 0;
        this.currentFile = undefined;
        this.submit = false;
      })
    },

    // upload() {
    //   if (!this.currentFile) {
    //     this.message = "Please select a file!";
    //     return;
    //   }

    //   this.message = "",
    //   this.FormData.file = this.currentFile,
    //   this.FormData.json.ClientTypeID = 1,
    //   this.FormData.json.ClientID = this.currentClient.ClientID,
    //   this.FormData.json.ColumnName = this.ColumnName,
    //   this.FormData.json.DocType = "Company",
    //   this.FormData.json.MakerID = this.currentUser.SecurityUserID,
    //   this.FormData.json.LastUserID = this.currentUser.SecurityUserID,

    //   UploadService.uploadKYCFile(this.FormData, (event) => {
    //     this.progress = Math.round((100 * event.loaded) / event.total);
    //   })
    //   .then(response => {
    //     this.Doc[`${this.ColumnName}`] = true;
    //     this.PendingDocs.push(response.data.filename);
    //     this.currentFile = undefined;
    //   })
    //   .catch(error => {
    //     this.progress = 0;
    //     this.message = (error.response && error.response.data.message) || error.message || error.toString();
    //     this.currentFile = undefined;
    //   });
    // },

    deleteDoc() {
      this.message = "";
      this.DocRecord[0][this.currentDoc.field] = false
      var data = {
        ClientId: this.currentClient.ClientID,
        DocType: "Company",
        filename: this.allKYCDocs.filter(a => a.ClientID == this.currentClient.ClientID && a.DocType == this.currentDoc.field && a.IsCurrent == true).map(a => a.FileName)[0],
        Doc: this.DocRecord[0]
      }
      this.deleteComDocument(data)
      .then(response =>{
        this.$socket.client.emit('socketreq', {
          commit: 'dltComDoc',
          data: data
        });
        this.message = response.data.message;
        this.deleteDialog = false
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    readDoc(item){
      var data = {
        DocType: "Company",
        FileName: this.allKYCDocs.filter(a => a.ClientID == this.currentClient.ClientID && a.DocType == item.field && a.IsCurrent == true).map(a => a.FileName)[0]
      }
      administrationService.readKYCDoc(data)
      .then(response =>{
        this.message = response.data.message;
        let pdfWindow = window.open("")
        pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(response.data.doc) + "'></iframe>")
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    selectFile(file) {
      this.progress = 0;
      this.currentFile = file;
      this.Doc[`${this.currentDoc.field}`] = true
    },

    close() {
      this.Doc.EmpoweringResolution = false,
      this.Doc.InvContract = false,
      this.Doc.cif = false,
      this.Doc.SigningMndt = false,
      this.Doc.IncorpCertificate = false,
      this.Doc.MemoArticles = false,
      this.Doc.ShareholdersRegister = false,
      this.Doc.DirectorsRegister = false,
      this.Doc.AuditedAccounts = false,
      this.Doc.AuthorisedSignatories = false,
      this.Doc.AccountCopies = false,
      this.Doc.RegisteredAddr = false,
      this.Doc.BankAccStat = false,
      this.Doc.BoardMinutes = false,
      this.Doc.VATNumber = false,
      this.Doc.LetterToAtria = false,
      this.submit = false,
      this.successful = false,
      this.create = false,
      this.message = "",
      this.$root.$emit("closeClientDialog")
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    setActiveDoc (item, index) {
      this.currentDoc = item
      this.currentIndex = index
    },
  },
}
</script>

<style scoped>
.v-btn {
  outline: none
}
</style>
